import { createApp, createSSRApp } from 'vue'
import App from './App.vue'
import router from './router'
import {store, useStoreKey } from './store'
//@ts-ignore
import { createVuestic } from 'vuestic-ui'
// import 'vuestic-ui/css'
//@ts-ignore
import 'vuestic-ui/styles/essential.css';
//@ts-ignore
import 'vuestic-ui/styles/typography.css';
//@ts-ignore
import '@/assets/tailwind.css'
import {createHead} from '@vueuse/head'

const head = createHead();


const app = createSSRApp(App).use(head).use(store, useStoreKey).use(router)
.use(
    createVuestic({
        config: {
            colors: {
                variables: {
                    color1: '#006d77',
                    color2: '#83c5be',
                    color3: '#edf6f9',
                    color4: '#ffddd2',
                    color5: '#e29578',
                }
            },
            
        },
    }))


router.isReady().then(() => {
    app.mount('#app')
    document.dispatchEvent(new Event('app-rendered'))
})  
